import getAxios from "./axiosService";

let STATICAPI = true;

let listService = {
  getCategory() {
    return new Promise((resolve, reject) => {
      let axios = getAxios(STATICAPI);
      axios.get('/api/book/category')
        .then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            console.error('Get comic category with error', res);
            reject();
          }
        })
    })
  },
  getBooks(category, currentPage, publishStatus) {
    return new Promise((resolve, reject) => {
      let axios = getAxios(STATICAPI);
      // axios.post('/api/book/list', {}, {
      //   params: {
      //     category,
      //     currentPage,
      //     publishStatus
      //   }
      // })
      axios.post(`/api/book/query/${publishStatus}/${category}/${currentPage}`)
        .then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            console.error('Get comics with error', res);
            reject();
          }
        })
    })
  },
  getLatest(target) {
    return new Promise((resolve, reject) => {
      let axios = getAxios(STATICAPI);
      //axios.get(`/api/book/recent_update?currentPage=${target}`)
      axios.get(`/api/book/new/${target}`)
        .then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            console.error('Get latest comics with error', res);
            reject();
          }
        })
    })
  },

  getCategoryBooks(category, currentPage, pageSize) {
    return new Promise((resolve, reject) => {
      let axios = getAxios();
      axios.get(`/api/book/today_update?category=${category}&pageSize=${pageSize}&currentPage=${currentPage}`)
        .then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            console.error('Get comics with error', res);
            reject();
          }
        })
    })
  },

  getMoreRecommend(target) {
    return getDetailList(target, 'e_recommend');
  },
  getMoreNew(target) {
    return getDetailList(target, 'new');
  },
  getMoreHot(target) {
    return getDetailList(target, 'hot');
  },
  getMoreKkbg(target) {
    return getDetailList(target, 'kkbg');
  },
  getMoreThreeD(target) {
    return getDetailList(target, 'three_d');
  },
  getMoreNewOn(target) {
    return getDetailList(target, 'new_on');
  },
  getMoreBzxz(target) {
    return getDetailList(target, 'bzxz');
  },
  getMoreDayUp(target, category, pageSize) {
    return getDayDetailList(target, category, pageSize);
  },
  getMoreRank(target, category, type) {
    return getRankDetailList(target, category, type);
  },
  getRefreshList(type, currentPage) {
    console.log(currentPage)
    return getHomeDetailList(type, currentPage);
  },

};

function getDetailList(target, type) {
  return new Promise((resolve, reject) => {
    let axios = getAxios(STATICAPI);
    //axios.get(`/api/book/showcase/detail?currentPage=${target}&type=${type}`)
    axios.get(`/api/book/showcase/detail/${type}/${target}`)
      .then(res => {
        if(res.status === 200) {
          resolve(res.data);
        }
        else {
          console.error('Get home detail list with error', res);
          reject();
        }
      })
  })
};
function getHomeDetailList(type, currentPage) {
  return new Promise((resolve, reject) => {
    let axios = getAxios(STATICAPI);
    axios.get(`/api/book/showcase/detail/${type}/${currentPage}`)
      .then(res => {
        if(res.status === 200) {
          resolve(res.data);
        }
        else {
          console.error('Get home detail list with error', res);
          reject();
        }
      })
  })
};
function getDayDetailList(target, category, pageSize) {
  return new Promise((resolve, reject) => {
    let axios = getAxios();
    //axios.get(`/api/book/showcase/detail?currentPage=${target}&type=${type}`)
    axios.get(`/api/book/today_update?category=${category}&pageSize=${pageSize}&currentPage=${target}`)
      .then(res => {
        if(res.status === 200) {
          resolve(res.data);
        }
        else {
          console.error('Get home detail list with error', res);
          reject();
        }
      })
  })
};
function getRankDetailList(target, category, type) {
  return new Promise((resolve, reject) => {
    let axios = getAxios();
    axios.get(`/api/book/rank?category=${category}&type=${type}&currentPage=${target} `)
      .then(res => {
        if(res.status === 200) {
          resolve(res.data);
        }
        else {
          console.error('Get home detail list with error', res);
          reject();
        }
      })
  })
};



export default listService



// WEBPACK FOOTER //
// ./src/services/listService.js